import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { QueryDefinitionDto } from '../../shared/dto/query-definition.dto';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ReportService } from '../../shared/report-service';
import { SelectItem } from 'primeng/api';
import { ViewNameDto } from '../../shared/dto/view-name.dto';
import { ColumnDefinitionDto } from '../../shared/dto/column-definition.dto';
import { SelectableColumnDefinitionDto } from '../../shared/dto/selectable-column-definition.dto';

@Component({
  selector: 'wl-query-tool-select-fields',
  templateUrl: './query-tool-select-fields.component.html',
  styleUrls: ['./query-tool-select-fields.component.less'],
    standalone: false
})
export class QueryToolSelectFieldsComponent implements OnInit, OnChanges {
  @Input() queryDefinition: QueryDefinitionDto;
  @Input() rawColumns: Array<ColumnDefinitionDto>;
  @Output() onViewChanged = new EventEmitter<string>();
  @Output() onFieldChanged = new EventEmitter<string>();
  availableFields = new Array<SelectableColumnDefinitionDto>();
  selectedColumns = new Array<ColumnDefinitionDto>();

  availableViews: Array<SelectItem>;
  initComplete = false;

  constructor(private _reportService: ReportService) {}

  ngOnInit(): void {
    this._reportService.getViews().then((data) => {
      this.availableViews = data
        .filter((x) => !!!x.Hide)
        .sort((a, b) => {
          if (a.ReplacementName > b.ReplacementName) {
            return 1;
          }

          if (a.ReplacementName < b.ReplacementName) {
            return -1;
          }

          return 0;
        })
        .map((x) => {
          return { label: x.ReplacementName, value: x.OriginalName } as SelectItem;
        });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.rawColumns) {
      if (this.queryDefinition.ViewName) {
        this.availableFields = this.rawColumns.map((x) => {
          const y = x as SelectableColumnDefinitionDto;
          y.Selected = false;
          return y;
        });
      }
      this.availableFields.forEach((x) => (x.Selected = this.queryDefinition.Fields.some((f) => f == x.ColumnName)));
      this.remapSelectedColumns();
    }
  }

  private remapSelectedColumns() {
    this.selectedColumns = this.queryDefinition.Fields.map((x) => this.availableFields.find((y) => y.ColumnName == x));
  }

  sorted(event) {
    moveItemInArray(this.selectedColumns, event.previousIndex, event.currentIndex);
    moveItemInArray(this.queryDefinition.Fields, event.previousIndex, event.currentIndex);
    this.onFieldChanged.emit();
  }

  addField(field: SelectableColumnDefinitionDto) {
    this.selectedColumns.push(field);
    this.queryDefinition.Fields.push(field.ColumnName);
    field.Selected = true;
    this.onFieldChanged.emit();
  }

  removeField(field: ColumnDefinitionDto) {
    const fieldIndex = this.queryDefinition.Fields.findIndex((x) => x == field.ColumnName);
    const targetField = this.availableFields.find((x) => x.ColumnName == field.ColumnName);
    this.queryDefinition.Fields.splice(fieldIndex, 1);
    this.selectedColumns.splice(fieldIndex, 1);
    if (targetField) {
      targetField.Selected = false;
    }
    this.onFieldChanged.emit();
  }

  viewChanged(viewName: string) {
    this.onViewChanged.emit(viewName);
    this.queryDefinition.Fields.splice(0, this.queryDefinition.Fields.length);
    this.selectedColumns.splice(0, this.selectedColumns.length);
  }
}
